import axios from 'axios';
import Const from './consts'
import BasicService from './basic.service';

export default class ApiBuy extends BasicService {
    api = Const.api;

    buy(company_code, assetline) {
        return axios.post(this.api + Const.path.buyAsset + '?company_code=' + company_code + '&asset_line=' + assetline, {});
    }

    confirm(company_code, info) {
        return axios.post(this.api + Const.path.confirmBuy +'?company_code=' + company_code, info);
    }
    
}


// WEBPACK FOOTER //
// ./src/utils/api.buy.js